import { render, staticRenderFns } from "./mo-functional-header-wrapper.html?vue&type=template&id=2b739d55&scoped=true&external"
import script from "./mo-functional-header-wrapper.ts?vue&type=script&lang=ts&external"
export * from "./mo-functional-header-wrapper.ts?vue&type=script&lang=ts&external"
import style0 from "./mo-functional-header-wrapper.scss?vue&type=style&index=0&id=2b739d55&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b739d55",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/agent/_work/2/s/Be.Vlaanderen.Mo.Vue/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b739d55')) {
      api.createRecord('2b739d55', component.options)
    } else {
      api.reload('2b739d55', component.options)
    }
    module.hot.accept("./mo-functional-header-wrapper.html?vue&type=template&id=2b739d55&scoped=true&external", function () {
      api.rerender('2b739d55', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/mo-functional-header-wrapper/mo-functional-header-wrapper.vue"
export default component.exports